module.exports = __webpack_public_path__ + "assets/shuben.3d2dadec.svg";